import { connect } from 'react-redux'
import { IAppState } from '../../../../store/types';
import PagamentoModalForm from './modal';

const mapStateToProps = (state: IAppState) => ({
  documentNumber: state.user.userInfo.documentNumber,
});

export default connect(mapStateToProps)(PagamentoModalForm);
